import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice d'energie du photon";
const DESCRIPTION =
  "Calculatrice d'energie du photon. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "photon energy, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/photon-energy-calculator/";

function PhotonEnergyCalculator() {
  const [method, setMethod] = useState("frequency");
  const [frequency, setFrequency] = useState("");
  const [wavelength, setWavelength] = useState("");
  const [energy, setEnergy] = useState(null);
  const [error, setError] = useState("");

  const h = 6.62607015e-34; // Planck constant in J·s
  const c = 299792458; // Speed of light in m/s

  const handleCalculate = () => {
    try {
      let energyValue = 0;

      if (method === "frequency") {
        if (!frequency) {
          setError("Veuillez entrer la fréquence");
          return;
        }
        energyValue = h * parseFloat(frequency);
      } else if (method === "wavelength") {
        if (!wavelength) {
          setError("Veuillez entrer la longueur d'onde");
          return;
        }
        energyValue = (h * c) / parseFloat(wavelength);
      }

      const energyEV = energyValue / 1.602176634e-19;

      setEnergy({
        joules: energyValue.toExponential(4),
        eV: energyEV.toFixed(4),
      });
      setError("");
    } catch (err) {
      setError(err.message);
      setEnergy(null);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  L'énergie d'un photon est déterminée par sa fréquence ou sa longueur d'onde. Elle est calculée en utilisant les formules:
                </p>
                <p>
                  <strong>E = hf = hc/λ</strong>
                </p>
                <p>où:</p>
                <ul>
                  <li>E = Énergie du photon (Joule)</li>
                  <li>h = Constante de Planck = 6.62607015 × 10⁻³⁴ J·s</li>
                  <li>f = Fréquence (Hz)</li>
                  <li>c = Vitesse de la lumière = 299,792,458 m/s</li>
                  <li>λ = Longueur d'onde (m)</li>
                </ul>
                <p>
                  Les photons avec une fréquence plus élevée ont une énergie plus grande. This calculator helps in quantum mechanics, spectroscopy, and understanding the behavior of light.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">Sélectionnez la méthode</label>
                      <select
                        value={method}
                        onChange={(e) => setMethod(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="frequency">À partir de la fréquence (Hz)</option>
                        <option value="wavelength">À partir de la longueur d'onde (m)</option>
                      </select>
                    </div>

                    {method === "frequency" && (
                      <div className="form-group">
                        <label className="form-label ms-2">Fréquence (Hz)</label>
                        <input
                          type="number"
                          value={frequency}
                          onChange={(e) => setFrequency(e.target.value)}
                          placeholder="Entrez la fréquence"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                      </div>
                    )}

                    {method === "wavelength" && (
                      <div className="form-group">
                        <label className="form-label ms-2">Longueur d'onde (m)</label>
                        <input
                          type="number"
                          value={wavelength}
                          onChange={(e) => setWavelength(e.target.value)}
                          placeholder="Entrez la longueur d'onde"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                      </div>
                    )}

                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {energy && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Énergie du photon:</h4>
                      <p>Énergie: {energy.joules} J (Joule)</p>
                      <p>Énergie: {energy.eV} eV (Électron-volt)</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Choisir la bonne methode de calcul</h3></div>
              <div className="info-section-body">
                <p>Utilisez la frequence si vous connaissez la valeur en hertz, ou la longueur d'onde si vous travaillez avec des donnees d'optique. Les deux methodes donnent la meme energie si les unites sont correctes.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Interpretration des resultats en Joule et eV</h3></div>
              <div className="info-section-body">
                <p>Le joule est l'unite SI, tandis que l'electron-volt est tres pratique en physique atomique et en spectroscopie. Une energie plus elevee correspond a une frequence plus grande et une longueur d'onde plus courte.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Erreurs frequentes</h3></div>
              <div className="info-section-body">
                <p>Attention aux puissances de dix: un mauvais exposant change completement le resultat. Verifiez aussi que la longueur d'onde est saisie en metres et non en nanometres sans conversion.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhotonEnergyCalculator;
